import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss/layout';
import {
  ICard,
  ICreditCardStatus,
  CreditCardsResponse,
  CreditCardsService
} from './../../services/credit-cards.service';

@Component({
  selector: 'ab-credit-card-list',
  templateUrl: './credit-card-list.component.html',
  styleUrls: ['./credit-card-list.component.scss']
})
export class CreditCardListComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  public cards: Array<ICard>;
  public selectedCard: ICard;
  public placeholder: string;
  public cardId: string;
  public CreditCardStatus = ICreditCardStatus;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private creditCardsService: CreditCardsService
  ) {}

  ngOnInit() {
    this.cardId = this.route.snapshot.queryParamMap.get('id');
    this.placeholder = (this.rendering.fields.placeholder as any).value;
    this.creditCardsService
      .getCreditCards()
      .subscribe(response => this.handleResponse(response));
  }

  handleResponse(response: CreditCardsResponse) {
    this.cards = response.cards;

    if (this.cards.length === 1) {
      this.selectedCard = this.cards[0];
      this.changeAccount(this.cardId ? true : false);
    } else {
      this.selectedCard = this.cards.filter(card => card.id === this.cardId)[0];
    }
  }

  changeAccount(stopRedirect = false) {
    if (stopRedirect !== true) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { id: this.selectedCard.id },
        queryParamsHandling: 'merge'
      });
    }
  }
}
